






























































































































































import { Component, Vue } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
import SingleImageUpload from '@/component/single-image-upload.vue';
const UPLOAD_DIR = {
  list_image: 'list_image',
  unit_image: 'unit_image',
};
const MAX_LENGTH = 8;
const _ = {
  keyBy: require('lodash/keyBy'),
  each: require('lodash/forEach'),
  map: require('lodash/map'),
};

// interface 接口定义 用来检测数据类型
interface Form {
  name: string;
  city: string;
  list_img_url: string;
  unit_img_url: [];
  unit_name: string;
}

// 必填项
interface Validator {
  field: string;
  validate: (value: any, avtivity: Form) => boolean;
  message: string;
  status: 'success' | 'error';
  help: string;
}

// 必填项提示信息列表
function getValidatorMap(): { [field: string]: Validator } {
  const list: any[] = [
    {
      field: 'name',
      validate: (value: string): boolean => !!value,
      message: '请输入名称',
    },
    {
      field: 'city',
      validate: (value: string): boolean => !!value,
      message: '请输入城市',
    },
    {
      field: 'list_img_url',
      validate: (value: string): boolean => !!value,
      message: '请选择列表图',
    },
    {
      field: 'unit_arr',
      validate: (value: any): boolean => value.detail.length > 0,
      message: '请选择户型图',
    },
  ].map((item): Validator => ({ ...item, status: 'success', help: '' }));
  return _.keyBy(list, (item: Validator) => item.field);
}
function getModalValidatorMap(): { [field: string]: Validator } {
  const list: any[] = [
    {
      field: 'unit_image',
      validate: (value: string): boolean => !!value,
      message: '请选择户型图',
    },
    {
      field: 'unit_area',
      validate: (value: string): boolean => value.length > 0,
      message: '请输入户型面积',
    },
  ].map((item): Validator => ({ ...item, status: 'success', help: '' }));
  return _.keyBy(list, (item: Validator) => item.field);
}
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  add_community: `${FCAPI}/shang/ruan/community`,
  add_unit: `${FCAPI}/shang/ruan/unit`,
  get_unit: `${FCAPI}/shang/ruan/unit/`,
  get_community: `${FCAPI}/shang/ruan/community/`,
  edit_community: `${FCAPI}/shang/ruan/community/`,
};
const NAME_MAX_LENGTH = 12;
const getUrl = require('baimahu/url-with-param');
function initForm(remote?: any) {
  remote = remote || {};
  return {
    name: remote.name || '',
    list_img_url: remote.list_img_url || '',
    city: remote.city || '',
    unit_image: remote.unit_image || '',
    unit_area: remote.unit_area || '',
    unit_arr: initData(),
  };
}
function initData(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    limit: remote.limit || 0,
    total: remote.total || 0,
  };
}
@Component({
  components: {
    SingleImageUpload,
  },
})
export default class AddTemplateRoom extends Vue {
  is_edit: boolean = false;
  is_loading: boolean = false;
  form_item_layout: any = {
    labelCol: { span: 2 },
    wrapperCol: { span: 22 },
  };
  delete_id_arr: any = [];
  validatorMap: { [field: string]: Validator } = getValidatorMap();
  modalValidatorMap: { [field: string]: Validator } = getModalValidatorMap();
  form: any = initForm();
  modal_image_src: string = '';
  is_show_image_modal: boolean = false;
  is_show_unit_modal: boolean = false;
  page: number = 1;
  new_unit: any = [];
  get uploadDir() {
    return UPLOAD_DIR;
  }

  get nameMaxLength() {
    return NAME_MAX_LENGTH;
  }

  get maxLength() {
    return MAX_LENGTH;
  }
  listBeforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  // 关闭新增户型图模态窗
  closeModal() {
    this.is_show_unit_modal = false;
    this.form.unit_area = '';
    this.form.unit_image = '';
  }

  // 点击新增户型图模态窗确定按钮
  @changeLoading(['is_loading'])
  async addUnit() {
    if (!this.validateCommit(this.modalValidatorMap)) {
      return;
    }
    if (this.$route.query.id) {
      this.new_unit.push({
        tag: this.form.unit_area,
        unit_img_url: this.form.unit_image,
        community_id: '',
      });
      this.new_unit.forEach((item: any) => {
        item.community_id = this.$route.query.id;
      });
      const res = await this.$axios.post(API.add_unit, {
        records: this.new_unit,
      });
      if (res.data.status !== 200) {
        this.$message.error((res as any).message);
        return;
      }
      this.new_unit = [];
      await this.getUnitData();
    } else {
      this.form.unit_arr.detail.push({
        tag: this.form.unit_area,
        unit_img_url: this.form.unit_image,
        community_id: '',
      });
    }
    this.closeModal();
  }

  // 删除户型图
  @changeLoading(['is_loading'])
  async deleteUnit(record: any, index: number) {
    if (this.is_edit) {
      const res = await this.$axios.delete(`${API.get_unit}${record.id}`);
      if (res.data.status !== 200) {
        this.$message.error((res as any).message);
        return;
      }
      await this.getUnitData(this.page);
    } else {
      this.form.unit_arr.detail.splice(index, 1);
    }
    this.$message.success('删除成功');
  }

  // 判断是否有必选项没有填
  validateCommit(validatorMap: any) {
    const form = this.form as any;
    let is_valid: boolean = true;
    _.each(validatorMap, (validator: Validator, field: string) => {
      if (!this.validate(field, validatorMap)) {
        is_valid = false;
      }
    });
    if (!is_valid) {
      this.$message.error('请填入必填项');
    }
    return is_valid;
  }

  validate(field: string, validatorMap: any) {
    const form = this.form as any;
    const is_valid = validatorMap[field].validate(form[field], form);
    validatorMap[field].status = is_valid ? 'success' : 'error';
    validatorMap[field].help = is_valid ? '' : validatorMap[field].message;
    return is_valid;
  }

  handlePreview(imageUrl: string) {
    console.log(imageUrl);
    this.modal_image_src = imageUrl;
    this.is_show_image_modal = true;
  }

  unitBeforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  // 点击提交按钮
  async submit() {
    if (!this.validateCommit(this.validatorMap)) {
      return;
    }
    const data = this.form;
    if (this.is_edit) {
      const res = await this.$axios.put(`${API.edit_community}${this.$route.query.id}`, {
        name: data.name,
        city: data.city,
        list_img_url: data.list_img_url,
      });
      if (res.data.status !== 200) {
        this.$message.error((res as any).message);
        return;
      }
      this.$router.go(-1);
      this.$message.success('新增小区成功');
    } else {
      const res = await this.$axios.post(API.add_community, {
        name: data.name,
        city: data.city,
        list_img_url: data.list_img_url,
      });
      if (res.data.status !== 200) {
        this.$message.error((res as any).message);
        return;
      }
      this.form.unit_arr.detail.forEach((item: any) => {
        item.community_id = res.data.data.id;
      });
      const res2 = await this.$axios.post(API.add_unit, {
        records: this.form.unit_arr.detail,
      });
      if (res2.status !== 200) {
        this.$message.error((res2 as any).message);
        return;
      }
      this.$router.go(-1);
      this.$message.success('新增小区成功');
    }
  }

  paginationOption(data: any) {
    if (this.is_edit) {
      return {
        showTotal: () => `共${data.total}条，每页${data.limit}条`,
        pageSize: data.limit || 0,
        total: data.total || 0,
        current: data.current || 0,
      };
    } else {
      return {
        showTotal: () => `共${data.detail.length}条，每页${5}条`,
        pageSize: 5,
        total: data.detail.length,
        current: this.page,
      };
    }
  }

  // 获取小区详情
  @changeLoading(['is_loading'])
  async getCommunityDetail() {
    const url = getUrl(`${API.get_community}${this.$route.query.id}/edit`, {
      id: this.$route.query.id,
    });
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.form = initForm(res.data.data);
  }

  // 切换户型图分页
  @changeLoading(['is_loading'])
  async handleChange(data: any) {
    if (this.is_edit) {
      await this.getUnitData(data.current);
    } else {
      this.page = data.current;
    }
  }

  // 获取户型图
  @changeLoading(['is_loading'])
  async getUnitData(current: number = 1) {
    const url = getUrl(API.get_unit, {
      community_id: this.$route.query.id,
      current,
    });
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    console.log(res.data.data);
    this.form.unit_arr = initData(res.data.data);
  }

  @changeLoading(['is_loading'])
  async created() {
    if (this.$route.query.id) {
      this.is_edit = true;
    }
    if (this.is_edit) {
      await this.getCommunityDetail();
      await this.getUnitData();
    }
  }
}
